import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { Reveal } from "../Reveal";

export const FAQ = ({ faqs }) => (
  <section id="faq" className="bg-ink-bg py-24 sm:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-6xl px-6">
      <div className="grid gap-12 lg:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]">
        <Reveal>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-accent">FAQ</p>
            <h2 className="mt-4 font-display text-3xl uppercase leading-none tracking-tight text-ink-text sm:text-4xl lg:text-5xl">
              Questions from the field
            </h2>
            <p className="mt-6 max-w-sm leading-relaxed text-ink-muted">
              Straight answers on units, waste factors and ordering — the details that decide whether the job finishes on the first delivery.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`q-${i}`}
                className="border-b border-ink-line"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-6 text-left text-base font-bold tracking-tight text-ink-text transition-colors duration-200 hover:text-accent hover:no-underline [&[data-state=open]>svg]:text-accent">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 leading-relaxed text-ink-muted">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
